import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface DialogState {
  open: boolean;
  type: 'custom' | 'confirmation';
  title?: React.ReactNode;
  confirmationText?: React.ReactNode;
  confirmButtonText?: React.ReactNode;
  content: React.ReactNode;
  loading: boolean;
  fullScreen: boolean;
  item: { name: string; id: string };
}

interface DialogActions {
  setLoading: (loading: boolean) => void;
  onConfirm: () => void;
  openDialog: (action: {
    type: 'custom' | 'confirmation';
    confirmButtonText?: React.ReactNode;
    confirmationText?: React.ReactNode;
    item?: { name: string; id: string };
    title?: React.ReactNode;
    fullScreen?: boolean;
    onConfirm?: () => void;
    element?: React.ReactNode;
  }) => void;
  closeDialog: () => void;
}

const initialState: DialogState = {
  open: false,
  type: 'custom',
  confirmButtonText: undefined,
  confirmationText: undefined,
  title: undefined,
  loading: false,
  fullScreen: false,
  content: undefined,
  item: { name: '', id: '' },
};

export const useDialogStore = create<DialogState & DialogActions>()(
  devtools((set) => ({
    ...initialState,
    onConfirm: () => {},
    setLoading: (loading) => set((state) => ({ ...state, loading })),
    openDialog: ({ type, item, title, fullScreen, element, onConfirm, confirmationText, confirmButtonText }) =>
      set(() => {
        return {
          open: true,
          item,
          title,
          type,
          fullScreen,
          confirmButtonText,
          confirmationText,
          content: element,
          onConfirm,
        };
      }),
    closeDialog: () => set((state) => ({ ...state, ...initialState })),
  })),
);
